import { Button } from "@mozioinc/ui";
import { useTranslation } from "react-i18next";
import DownloadSvg from "../components/assets/download.svg?react";
import { useShowMobileAppDownload } from "../hooks/use-show-mobile-app-download";
import { onMobileAppDownloadClick } from "../utils/mobile-app";
import type { TransNamespace } from "../types";

export const MobileAppDownloadButton = () => {
  const { t } = useTranslation<TransNamespace>("transfer:header");
  const { isButtonShown } = useShowMobileAppDownload();

  if (!isButtonShown) return null;

  const text = t("Download App");
  return (
    <div className={"flex w-full justify-center"}>
      <Button variant={"outline"} onClick={onMobileAppDownloadClick}>
        <DownloadSvg className={"text-2xl"} />
        <span className={text.length < 15 ? "text-md" : "text-xs leading-none"}>
          {text}
        </span>
      </Button>
    </div>
  );
};
